<template>
  <component
    :is="element"
    :disabled="element === 'button' ? disabled : null"
    :class="[
      size,
      buttonStyle,
      fixedWidth ? 'fixed-width' : '',
      disabled ? 'disabled' : ''
    ]"
    :href="href"
    :target="target"
  >
    <div
      v-if="!!$slots['icon']"
      :class="`icon ${!$slots.default ? '' : 'mr'}`"
    >
      <slot name="icon" />
    </div>
    <span class="text">
      <slot />
    </span>
  </component>
</template>

<script>
export default {
  props: {
    element: {
      type: String,
      default: 'button',
      validator(value) {
        return ['button', 'a'].includes(value)
      },
    },
    href: {
      type: [String, null],
      default: null,
    },
    target: {
      type: [String, null],
      default: null,
    },
    size: {
      type: String,
      default: 'sm',
      validator(value) {
        return ['sm', 'md', 'lg'].includes(value)
      }
    },
    buttonStyle: {
      type: String,
      default: 'primary',
      validator(value) {
        return ['primary', 'primary-outline', 'secondary', 'custom', 'danger'].includes(value)
      }
    },
    fixedWidth: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      required: false,
      default: false,
    }
  },
}
</script>

<style lang="scss" scoped>
a, button {
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 0.75rem;
  line-height: 1;
  letter-spacing: -0.5px;
  transition: .25s;

  &.fixed-width {
    width: 185px;
  }

  &.sm {
    font-size: 14px;
    padding: 0.25rem 1.5rem;
    border-radius: 0.5rem;
  }

  &.md {
    font-size: 16px;
    padding: .75rem 1.5rem;
  }

  &.lg {
    font-size: 18px;
    padding: 1.5rem;
  }

  .icon {
    &.mr {
      margin-right: .5rem;
    }

    :deep(path) {
      stroke: #FFFFFF;
    }
  }

  &.disabled {
    pointer-events: none;
  }
}

.primary {
  background-color: var(--primary-color);
  color: white;
  border: 2px solid var(--primary-color);

  &:hover {
    background-color: #0A8080;
    border-color: #0A8080;
  }
}

.danger {
  background-color: var(--negative-color);
  color: white;
  border: 2px solid var(--negative-color);;

  &:hover {
    background-color: var(--negative-color-dark);
    border-color: var(--negative-color-dark);
  }
}

.secondary {
  background-color: var(--secondary-color);
  color: white;
  border: 2px solid var(--secondary-color);;

  &:hover {
    background-color: var(--secondary-color-dark);
    border-color: var(--secondary-color-dark);
  }
}

.primary-outline {
  background-color: #FFFFFF;
  color: var(--primary-color);;
  border: 2px solid var(--primary-color);;

  &:hover {
    border-color: var(--primary-color-dark);
    color: var(--primary-color-dark);

    > .icon :deep(path) {
      stroke: var(--primary-color-dark);
    }
  }
}
</style>

